<p-autoComplete
  unique="true"
  [appendTo]="appendTo"
  [minLength]="3"
  [suggestions]="suggestions"
  [field]="optionLabel"
  [multiple]="multiple"
  [(ngModel)]="selected"
  [disabled]="disabled"
  (completeMethod)="searchUsers($event)"
  [forceSelection]="true"
  (onSelect)="onSelect()"
  (onClear)="onSelect()"
  (onUnselect)="onSelect()"
  [emptyMessage]="generalTexts.noData.label"
  [placeholder]="generalTexts.search.label"
></p-autoComplete>
